import { Directive } from "vue";

export const vFocus: Directive = {
    updated(el, { value }) {
        value && setTimeout(() => el.focus());
    }
}
